import { Theme } from '@mui/material';

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

export const useNewMemberFlowStyles = makeStyles((theme: Theme) =>
  createStyles({
    stepperWrapper: {
      marginBottom: '50px',
      [theme.breakpoints.down('sm')]: {
        marginBottom: '0',
      },
    },
    stepperIcon: {
      borderRadius: '17.5px',
      height: '22px',
      width: '22px',
      border: `2px solid ${theme.customPalette.red}`,
    },
    stepperIconComplete: {
      backgroundColor: theme.customPalette.red,
    },
    activeStepperText: {
      fontWeight: theme.fontWeight,
    },
    contentHeader: {
      display: 'flex',
      justifyContent: 'center',
      [theme.breakpoints.down('sm')]: {
        fontSize: '16px',
        fontWeight: theme.fontWeight,
      },
    },
    content: {
      display: 'flex',
      justifyContent: 'center',
      paddingTop: '50px',
      [theme.breakpoints.down('sm')]: {
        paddingTop: '20px',
        paddingLeft: '39.5px',
        paddingRight: '28.5px',
      },
    },
    centerContent: {
      width: '500px',
    },
    mobileComponentWrapper: {
      paddingLeft: '34px',
      paddingRight: '10px',
    },
  })
);
